<template>
  <div id="infocode">

    <v-dialog v-model="dialog" width="850">
      <template v-slot:activator="{ on }">
        <v-btn class="text-none infobutton" color="white" flat dark v-on="on">
          ¿Qué es eso? 
        </v-btn>
      </template>
 
      <v-card style="border-radius:10px" class="pb-5">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn  fab flat color="#B4347E" small @click="dialog = false">
            <v-icon x-large>cancel</v-icon>
          </v-btn>
        </v-card-actions>
        
        <v-flex md12 lg12>
          <v-card-title >
            <v-flex md12 lg7>
              <div align="center">
                <img class="hidden-xs-only" src="arte_tarjeta_Lalabum.png">
                <img class="hidden-sm-and-up" src="arte_tarjeta_Lalabum.png" width="250px" height="205px">
              </div>
            </v-flex>

            <v-flex xs12 md12 lg5>        
              <p class="tarjetalalabum" >Tarjeta Lalabum </p>
              <p class="textinfo" >Es un código de acceso a la aplicación mundo lalabum y los recursos multimedia del programa Lalabum durante un ciclo escolar para que tú y tu familia disfruten de poner sus valores en acción. </p>
              <span class="textinfo" >Para tener mayor información</span><br>
              <span class="textinfo" >visita el sitio oficial:</span><br>
              <a class="textinfo" href="https://www.lalabumapp.com/" >www.lalabumapp.com</a><br>
              <span class="textinfo" >01 800 890 96 65</span><br>
              <a href="mailto:info@lalabumapp.com" style="color:#558bc3"><span class="extrainfo" >info@lalabumapp.com</span></a>
            </v-flex>
          </v-card-title>
        </v-flex>
      </v-card>    
    </v-dialog>
  </div>
</template>


<script>
export default {
    data(){
        return{
            dialog:false,
        }
    }
}
</script>


<style>
.infobutton{
    font-family:Poppins;
    font-weight:400;
    text-decoration:underline;
  }
  .tarjetalalabum{
    color:#558bc3;
    font-family:Fredoka one; 
    font-weight:500;
  }
  .textinfo{
    color:#558bc3 ;
    font-family:Poppins;
    font-weight:400;
  }

@media (min-width: 1200px){
  .infobutton{    
    font-size:1.8vw;    
  }
  .tarjetalalabum{
    font-size:2.3vw;
  }
  .textinfo{
    font-size:1.2vw;
  }

}

@media (min-width: 300px) and (max-width: 1100px){
  .infobutton{ 
    font-size:4.8vw;
  }
  .tarjetalalabum{
    font-size:6.3vw;
    text-align: center;
  }
  .textinfo{
    font-size:4.2vw;
  }
}
</style>
